export function getEnumKey(
  enumData: Record<string, unknown>,
  value: any,
): string {
  const enumDataArr = Object.entries(enumData).filter(([k, v]) => v === value)

  if (!enumDataArr.length) {
    return ''
  }

  return enumDataArr[0][0]
}
